import React, {Component} from "react";
import {Buffer} from "buffer";
import {Button, Col, DatePicker, Divider, Form, Input, Modal, Row, Spin} from "antd";
import {offerApiServices} from "../../services/offer/OfferApiService";
import AreaProvinceSelect from "../area/AreaProvinceSelect";
import AreaCitySelect from "../area/AreaCitySelect";
import AreaDistrictSelect from "../area/AreaDistrictSelect";
import AreaSubdistrictSelect from "../area/AreaSubdistrictSelect";
import Cookies from "universal-cookie";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import CurrencyInput from "react-currency-input-field";

class UpdateShippingAddressOffer extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            dealerCode: "",
            offerCode: "",
            dataDetailStock: {},
            fetchingDetailOffer: false,
            shippingAddressFullAddress: "",
            shippingAddressPostalCode: "",
            shippingAddressProvinceCode: "",
            shippingAddressProvinceName: "",
            shippingAddressCityCode: "",
            shippingAddressCityName: "",
            shippingAddressDistrictCode: "",
            shippingAddressDistrictName: "",
            shippingAddressSubdistrictCode: "",
            shippingAddressSubdistrictName: "",
            shippingAddressLocationPoint: "",
            updateProcess: false,

            shippingDataMediatorName: "",
            shippingDataMediatorPhoneNumber: "",
            shippingDataMediatorAmount: 0,
            shippingDataCustomerCod: 0,
            shippingDataDate: moment(new Date(), "YYYY-MM-DD"),
            shippingDataCreditPaymentDate: moment(new Date(), "YYYY-MM-DD"),
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            dealerCode: this.props.dealerCode,
            offerCode: this.props.offerCode,
            fetchingDetailOffer: true,
        });

        this.showOfferDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.dealerCode !== prevProps.dealerCode) {
            console.log('diff dealer');
        }

        if (this.props.offerCode !== prevProps.offerCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                fetchingDetailOffer: true,
            });
        }

        if (this.props.time !== prevProps.time) {
            this.showOfferDetail();
        }
    }

    showOfferDetail = async () => {

        await this.promisedSetState({
            dealerCode: "",
            offerCode: "",
            dataDetailStock: {},
            fetchingDetailOffer: false,
            shippingAddressFullAddress: "",
            shippingAddressPostalCode: "",
            shippingAddressProvinceCode: "",
            shippingAddressProvinceName: "",
            shippingAddressCityCode: "",
            shippingAddressCityName: "",
            shippingAddressDistrictCode: "",
            shippingAddressDistrictName: "",
            shippingAddressSubdistrictCode: "",
            shippingAddressSubdistrictName: "",
            shippingAddressLocationPoint: "",
            updateProcess: false,

            shippingDataMediatorName: "",
            shippingDataMediatorPhoneNumber: "",
            shippingDataMediatorAmount: 0,
            shippingDataCustomerCod: 0,
            shippingDataDate: moment(new Date(), "YYYY-MM-DD"),
            shippingDataCreditPaymentDate: moment(new Date(), "YYYY-MM-DD"),
        });

        await offerApiServices.getDetailOffer({
            offerCode: this.props.offerCode,
        }).then(async value => {
            await this.promisedSetState({
                dataDetailStock: value.data.data,
                fetchingDetailOffer: false,
                shippingAddressProvinceCode: (value.data.data.address_shipping.province_code) ? value.data.data.address_shipping.province_code : value.data.data.address_owner.province_code,
                shippingAddressProvinceName: (value.data.data.address_shipping.province_name) ? value.data.data.address_shipping.province_name : value.data.data.address_owner.province_name,
                shippingAddressCityCode: (value.data.data.address_shipping.city_code) ? value.data.data.address_shipping.city_code : value.data.data.address_owner.city_code,
                shippingAddressCityName: (value.data.data.address_shipping.city_name) ? value.data.data.address_shipping.city_name : value.data.data.address_owner.city_name,
                shippingAddressDistrictCode: (value.data.data.address_shipping.district_code) ? value.data.data.address_shipping.district_code : value.data.data.address_owner.district_code,
                shippingAddressDistrictName: (value.data.data.address_shipping.district_name) ? value.data.data.address_shipping.district_name : value.data.data.address_owner.district_name,
                shippingAddressSubdistrictCode: (value.data.data.address_shipping.sub_district_code) ? value.data.data.address_shipping.sub_district_code : value.data.data.address_owner.sub_district_code,
                shippingAddressSubdistrictName: (value.data.data.address_shipping.sub_district_name) ? value.data.data.address_shipping.sub_district_name : value.data.data.address_owner.sub_district_name,
                shippingAddressFullAddress: (value.data.data.address_shipping.full_address) ? value.data.data.address_shipping.full_address : value.data.data.address_owner.full_address,
                shippingAddressPostalCode: (value.data.data.address_shipping.zip_code) ? value.data.data.address_shipping.zip_code : value.data.data.address_owner.zip_code,
                shippingAddressLocationPoint: value.data.data.address_shipping?.location_point?.point ?? "",

                shippingDataMediatorName: value.data.data.data_shipping?.mediator_name ?? "",
                shippingDataMediatorPhoneNumber: value.data.data.data_shipping?.mediator_phone_number ?? "",
                shippingDataMediatorAmount: value.data.data.data_shipping?.mediator_credit_amount ?? 0,
                shippingDataCustomerCod: value.data.data.data_shipping?.customer_cash_on_delivery ?? 0,
                shippingDataDate: (value.data.data.data_shipping?.shipping_date) ? moment(value.data.data.data_shipping?.shipping_date, "YYYY-MM-DD") : moment(new Date(), "YYYY-MM-DD"),
                shippingDataCreditPaymentDate: (value.data.data.data_shipping?.shipping_credit_payment_date) ? moment(value.data.data.data_shipping?.shipping_credit_payment_date, "YYYY-MM-DD") : moment(new Date(), "YYYY-MM-DD")
            });
        }).catch(async reason => {
            await this.promisedSetState({
                dataDetailStock: {},
                fetchingDetailOffer: false,
            });
        });
    }

    onFieldChange = <T extends keyof Pick<any, "shippingDataCustomerCod" | "shippingDataCreditPaymentDate" | "shippingDataDate" | "shippingAddressFullAddress" | "shippingAddressPostalCode" | "shippingAddressLocationPoint" | "shippingDataMediatorName" | "shippingDataMediatorPhoneNumber" | "shippingDataMediatorAmount">>(target: T, value: any) => {
        const currentState = {...this.state};
        switch (target) {
            case "shippingDataCustomerCod":
                currentState.shippingDataCustomerCod = value;
                break;
            case "shippingDataDate":
                currentState.shippingDataDate = value;
                break;
            case "shippingAddressFullAddress":
                currentState.shippingAddressFullAddress = value;
                break;
            case "shippingAddressPostalCode":
                currentState.shippingAddressPostalCode = value;
                break;
            case "shippingAddressLocationPoint":
                currentState.shippingAddressLocationPoint = value;
                break;
            case "shippingDataMediatorName":
                currentState.shippingDataMediatorName = value?.toUpperCase();
                break;
            case "shippingDataMediatorPhoneNumber":
                currentState.shippingDataMediatorPhoneNumber = value.replace(/[^0-9.]/g, '');
                break;
            case "shippingDataMediatorAmount":
                currentState.shippingDataMediatorAmount = value;
                break;
        }

        if (target === 'shippingDataMediatorPhoneNumber') {
            if (currentState.shippingDataMediatorPhoneNumber.length > 1) {
                if (currentState.shippingDataMediatorPhoneNumber.substring(0, 2) !== '08') {
                    currentState.shippingDataMediatorPhoneNumber = "";
                }
            }
        }

        this.setState({
            ...currentState,
        });
    }

    onAreaProvinceChange = (data: any) => {
        this.setState({
            shippingAddressProvinceCode: data.value,
            shippingAddressProvinceName: data.children,
            shippingAddressCityCode: null,
            shippingAddressCityName: null,
            shippingAddressDistrictCode: null,
            shippingAddressDistrictName: null,
            shippingAddressSubdistrictCode: null,
            shippingAddressSubdistrictName: null,
            shippingAddressPostalCode: "",
        });
    }

    onAreaCityChange = (data: any) => {
        this.setState({
            shippingAddressCityCode: data.value,
            shippingAddressCityName: data.children,
            shippingAddressDistrictCode: null,
            shippingAddressDistrictName: null,
            shippingAddressSubdistrictCode: null,
            shippingAddressSubdistrictName: null,
            shippingAddressPostalCode: "",
        });
    }

    onAreaDistrictChange = (data: any) => {
        this.setState({
            shippingAddressDistrictCode: data.value,
            shippingAddressDistrictName: data.children,
            shippingAddressSubdistrictCode: null,
            shippingAddressSubdistrictName: null,
            shippingAddressPostalCode: "",
        });
    }

    onAreaSubdistrictChange = (data: any) => {
        this.setState({
            shippingAddressSubdistrictCode: data.value,
            shippingAddressSubdistrictName: data.children,
            shippingAddressPostalCode: data?.postalCode,
        });
    }

    onUpdateData = async () => {
        const latLng = this.state.shippingAddressLocationPoint.split(',');
        const dataUpdate = {
            update_type: "address-shipping",
            company: this.props.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            dealer_code: this.props.dealerCode,
            offer_code: this.props.offerCode,
            address_shipping: {
                full_address: this.state.shippingAddressFullAddress,
                province_code: this.state.shippingAddressProvinceCode,
                province_name: this.state.shippingAddressProvinceName,
                city_code: this.state.shippingAddressCityCode,
                city_name: this.state.shippingAddressCityName,
                district_code: this.state.shippingAddressDistrictCode,
                district_name: this.state.shippingAddressDistrictName,
                sub_district_code: this.state.shippingAddressSubdistrictCode,
                sub_district_name: this.state.shippingAddressSubdistrictName,
                zip_code: this.state.shippingAddressPostalCode,
                location_point: {
                    point: this.state.shippingAddressLocationPoint,
                    lat: latLng?.[0]?.trim(),
                    lng: latLng?.[1]?.trim(),
                }
            },
            data_shipping: {
                mediator_name: this.state.shippingDataMediatorName?.trim(),
                mediator_phone_number: this.state.shippingDataMediatorPhoneNumber,
                mediator_credit_amount: this.state.shippingDataMediatorAmount,
                customer_cash_on_delivery: this.state.shippingDataCustomerCod,
                shipping_date: moment(this.state?.shippingDataDate).format("YYYY-MM-DD"),
                shipping_credit_payment_date: moment(this.state?.shippingDataCreditPaymentDate).format("YYYY-MM-DD"),
            }
        };
        if (!this.state.shippingAddressFullAddress) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Alamat Lengkap"});
            return false;
        }
        if (!this.state.shippingAddressPostalCode) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi kode pos"});
            return false;
        }
        if (!this.state.shippingAddressProvinceCode) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Provinsi"});
            return false;
        }
        if (!this.state.shippingAddressCityCode) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Kota"});
            return false;
        }
        if (!this.state.shippingAddressDistrictCode) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Kecamatan"});
            return false;
        }
        if (!this.state.shippingAddressSubdistrictCode) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Kelurahan"});
            return false;
        }

        await this.promisedSetState({
            updateProcess: true,
        });

        try {
            await offerApiServices.updateOffer(dataUpdate)
                .then(successData => {
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'Offer berhasil di update '
                    });
                    this.setState({
                        updateProcess: false,
                    });
                    this.props.onCloseUpdateShippingAddressProps("close");
                });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                updateProcess: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailOffer ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>
                <div style={!this.state.fetchingDetailOffer ? {} : {display: 'none'}}>
                    <Row>
                        <Col xl={{span: 12}} lg={{span: 12}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}} style={{paddingLeft: 20}}>
                            <Divider orientation="left" plain>Alamat Pengiriman</Divider>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Alamat *</i>
                                <TextArea showCount maxLength={200} value={this.state.shippingAddressFullAddress} onChange={event => this.onFieldChange("shippingAddressFullAddress", event.target.value)} placeholder="Alamat"/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Provinsi *</i>
                                <AreaProvinceSelect onAreaProvinceChangeProps={this.onAreaProvinceChange} country={"idn"} provinceCode={this.state.shippingAddressProvinceCode} provinceName={this.state.shippingAddressProvinceName}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Kota / Kabupaten *</i>
                                <AreaCitySelect onAreaCityChangeProps={this.onAreaCityChange} provinceCode={this.state.shippingAddressProvinceCode} cityName={this.state.shippingAddressCityName}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Kecamatan *</i>
                                <AreaDistrictSelect onAreaDistrictChangeProps={this.onAreaDistrictChange} cityCode={this.state.shippingAddressCityCode} districtName={this.state.shippingAddressDistrictName}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Kelurahan *</i>
                                <AreaSubdistrictSelect onAreaSubdistrictChangeProps={this.onAreaSubdistrictChange} districtCode={this.state.shippingAddressDistrictCode} subdistrictName={this.state.shippingAddressSubdistrictName}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Kode Pos *</i>
                                <Input value={this.state.shippingAddressPostalCode} placeholder="Kodepos" onChange={event => this.onFieldChange("shippingAddressPostalCode", event.target.value)}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Point Lokasi *</i>
                                <Input value={this.state.shippingAddressLocationPoint} placeholder="Point Lokasi Lat,Lng" onChange={event => this.onFieldChange("shippingAddressLocationPoint", event.target.value)}/>
                            </Form.Item>
                        </Col>
                        <Col xl={{span: 12}} lg={{span: 12}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}} style={{paddingLeft: 20}}>
                            <Divider orientation="left" plain>Data Tambahan Pengiriman</Divider>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Nama Mediator *</i>
                                <Input value={this.state.shippingDataMediatorName} placeholder="Nama Mediator" onChange={event => this.onFieldChange("shippingDataMediatorName", event.target.value)}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Nomor Telpon Mediator *</i>
                                <Input value={this.state.shippingDataMediatorPhoneNumber} placeholder="Nomor Telpon Mediator" onChange={event => this.onFieldChange("shippingDataMediatorPhoneNumber", event.target.value)}/>
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Uang yang diterima Mediator *</i>
                                <CurrencyInput
                                    className={'ant-input'}
                                    value={this.state.shippingDataMediatorAmount}
                                    onValueChange={value => this.onFieldChange("shippingDataMediatorAmount", value ? parseFloat(value) : 0)}
                                />
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Uang yang diambil di Konsumen *</i>
                                <CurrencyInput
                                    className={'ant-input'}
                                    value={this.state.shippingDataCustomerCod}
                                    onValueChange={value => this.onFieldChange("shippingDataCustomerCod", value ? parseFloat(value) : 0)}
                                />
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Tanggal Pengiriman *</i>
                                <DatePicker
                                    disabledDate={(current) => current && current <= moment().endOf("day").subtract(1, 'days')}
                                    value={moment(this.state.shippingDataDate, "YYYY-MM-DD")}
                                    onChange={(event) => this.onFieldChange("shippingDataDate", event)}
                                    format={"YYYY-MM-DD"}
                                    style={{width: "100%"}}
                                />
                            </Form.Item>
                            <Form.Item>
                                <i className={`text-small-grey-nopadding`}>Tanggal Jatuh Tempo *</i>
                                <DatePicker
                                    disabledDate={(current) => current && current <= moment().endOf("day").subtract(1, 'days')}
                                    value={moment(this.state.shippingDataCreditPaymentDate, "YYYY-MM-DD")}
                                    onChange={(event) => this.onFieldChange("shippingDataCreditPaymentDate", event)}
                                    format={"YYYY-MM-DD"}
                                    style={{width: "100%"}}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button style={{marginTop: 20}} type={"primary"} loading={this.state.updateProcess} onClick={() => this.onUpdateData()}> Update Data</Button>
                </div>
            </React.Fragment>
        );
    }
}

export default UpdateShippingAddressOffer;
